export default __webpack_public_path__ + "static/GIF_Versandumschlag-f08e908e97c0570f4856ee88e67f55db.gif";